import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

type NavigateToOptions = {
  replace?: boolean;
};

const useLocaleNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  const localeUrl = (path: string) => {
    if (path && path.indexOf('http') >= 0) return path;
    let retPath: string | null = null;
    if (path && path[0] === '/') {
      retPath = `/${(i18n && i18n.language) || 'en'}${path}`;
    } else {
      retPath = `/${(i18n && i18n.language) || 'en'}/${path}`;
    }
    return retPath.replace('/en/', '/');
  };

  /**
   * Navigates to the given path, but only if it's not the current path.
   * Automatically prepends the locale.
   * @param path The target path (should start with '/')
   * @param options Optional navigation settings
   */
  const navigateTo = (path: string, options?: NavigateToOptions) => {
    const target = localeUrl(path);
    const current = location.pathname + location.search;

    if (current !== target) {
      navigate(target, { replace: options?.replace ?? false });
    }
  };

  return { navigateTo, localeUrl };
};

export default useLocaleNavigate;
